import { hasValue } from 'Lib/Any';
import className from 'classnames';
import React, { useState } from 'react';
import { FaRegFolderOpen } from 'react-icons/fa';
import { Label, TextInput } from '..';
import { Field } from '../Field';
import { withInjectedProps } from '../InjectedPropsContext';
import { ChangeEventWithData } from '../types';
import './FileUpload.scss';

export type IFileUploadProps = Pick<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  'id' | 'name' | 'placeholder'
> & {
  label?: string;
  acceptFileExtensions?: string;
  onChange: (event: ChangeEventWithData<HTMLInputElement, File>) => void;
};

const FileUploadBase: React.FC<IFileUploadProps> = ({ id, placeholder, label, acceptFileExtensions, onChange }) => {
  const [selectedFileName, setSelectedFileName] = useState('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];

    if (hasValue(selectedFile)) {
      setSelectedFileName(selectedFile?.name ?? '');

      if (onChange) {
        (event as ChangeEventWithData<HTMLInputElement, File>).data = { value: selectedFile, submitValues: true };
        onChange(event);
      }
    }
  };

  return (
    <div className={className('File-Upload-Container')}>
      <Label className={className('File-Upload-Label')}>{label}</Label>
      <Field
        input={<TextInput />}
        disabled
        placeholder={placeholder ?? 'Select a file to upload'}
        fieldAdditionalClassName={className('File-Upload-Filename')}
        value={selectedFileName}
      />
      <Label htmlFor={id} className={className('File-Upload-Button')}>
        <FaRegFolderOpen />
        <input id={id} type="file" style={{ display: 'none' }} onChange={handleChange} accept={acceptFileExtensions} />
      </Label>
    </div>
  );
};

const FileUpload = withInjectedProps(FileUploadBase);

export { FileUpload };
export default FileUpload;
